import {AppForm} from '../../../../../../../common/forms/app.form';
import {Injectable} from '@angular/core';
import {FormArray, FormControl, Validators} from '@angular/forms';
import {
  LocationDecisionAppEntityLocationDecisionWrite,
  RoadOccupationAppEntityApplicationRead,
  RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee
} from '../../../../../../../openapi';
import {
  OccupationOfLanePlacementConstructionObjectsStageForm,
  OccupationOfLanePlacementConstructionObjectsStageFormValue,
  toStageFormValue
} from './occupation-of-lane-placement-construction-objects-stage.form';

export function occupationsToFormValue(occupations: Array<RoadOccupationAppEntityApplicationRead>): OccupationOfLanePlacementConstructionObjectsFormValue[] {
  return occupations
    .sort((a, b) => (b?.ordinalNumber || 0) - (a?.ordinalNumber || 0))
    .map(v => {
      return {
        locationDecisions: v?.locationDecisions?.map(v => ({
          decisionNumber: v.decisionNumber,
          decisionDate: v.decisionDate
        })) || [],
        stages: [...v.stages || []]
          .sort((a, b) => (b?.ordinalNumber || 0) - (a?.ordinalNumber || 0))
          .map(stage => toStageFormValue(stage)) || []
      };
    });
}

export interface OccupationOfLanePlacementConstructionObjectsFormValue {
  locationDecisions: LocationDecisionAppEntityLocationDecisionWrite[];
  stages: OccupationOfLanePlacementConstructionObjectsStageFormValue[];
}

@Injectable()
export class OccupationOfLanePlacementConstructionObjectsForm extends AppForm {
  constructor() {
    super({
      locationDecisions: new FormControl([], {
        nonNullable: true,
        validators: [Validators.required, Validators.minLength(1), Validators.maxLength(255)]
      }),
      stages: new FormArray([
        new OccupationOfLanePlacementConstructionObjectsStageForm()
      ])
    });
  }

  public get locationDecisions(): FormControl | null {
    return this.get('locationDecisions') as FormControl | null;
  }

  public addStage(fees: RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee[]): void {
    const f = new OccupationOfLanePlacementConstructionObjectsStageForm();
    f.createPurposeFeesForms(fees, []);
    this.stages.push(f);
  }

  public removeStage(i: number): void {
    this.stages.removeAt(i);
  }

  public get stages(): FormArray {
    return this.get('stages') as FormArray;
  }

  public getStageForms(): OccupationOfLanePlacementConstructionObjectsStageForm[] {
    return this.stages.controls as OccupationOfLanePlacementConstructionObjectsStageForm[];
  }

  public override get valid(): boolean {
    return super.valid && !!this.stages.controls.map(c => c.valid).filter(v => v).length;
  }

  public override patchFormValues(data: {
    value: OccupationOfLanePlacementConstructionObjectsFormValue | null;
    purposeFeeCollection: RoadOccupationPurposeFeeAppEntityDictionaryRoadOccupationPurposeFee[];
  }): void {
    super.patchFormValues(data.value);

    this.stages.clear();
    (data.value?.stages || []).forEach(stage => {
      const sf = new OccupationOfLanePlacementConstructionObjectsStageForm();
      sf.patchFormValues({
        ...stage
      });
      sf.createPurposeFeesForms(data.purposeFeeCollection, stage.purposeFees);
      this.stages.push(sf);
    });

    if (!this.stages.length) {
      const sf = new OccupationOfLanePlacementConstructionObjectsStageForm();
      sf.createPurposeFeesForms(data.purposeFeeCollection, []);
      this.stages.push(sf);
    }
  }

  public get values(): OccupationOfLanePlacementConstructionObjectsFormValue {
    return {
      locationDecisions: this.locationDecisions?.value || [],
      stages: this.getStageForms().map(f => f.values) || []
    };
  }
}
